import { __ } from '@eventespresso/i18n';

export const datetimesDroppableId = 'date-entities-droppable';

export const datetimeStatus = {
	isActive: __('Active'),
	isCancelled: __('Cancelled'),
	isExpired: __('Expired'),
	isInactive: __('Inactive'),
	isPostponed: __('Postponed'),
	isSoldOut: __('SoldOut'),
	isUpcoming: __('Upcoming'),
};
